'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var now = exports.now = function now() {
  return Date.now();
};

var durationFormat = exports.durationFormat = function durationFormat(value) {
  var duration = Math.abs(value);
  var PER_HOUR = 60 * 60 * 1000;
  var PER_MINUTE = 60 * 1000;
  var PER_SECOND = 1000;

  var hour = Math.floor(duration / PER_HOUR);
  duration -= hour * PER_HOUR;

  var minute = Math.floor(duration / PER_MINUTE);
  duration -= minute * PER_MINUTE;

  var second = Math.floor(duration / PER_SECOND);
  var label = '' + (hour > 0 ? hour + ' 小时 ' : '') + (minute > 0 ? minute + ' 分钟' : '');

  if (hour === 0 && minute === 0) {
    label = second + ' \u79D2';
  }

  return label;
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/order-dialog/src/utils/time.js
// module id = 175
// module chunks = 0